<template>
  <div style="display: flex;">
    <div>
      <i class="fas fa-info-square text-primary" style="font-size: x-large; padding-top: 13px; cursor: pointer;" @click="showInfoModal = !showInfoModal"></i>
    </div>
    <div style="margin-left: auto; width: 155px;">
      <div class="fs-xs fw-semibold my-2">
        <span style="float: left;">{{ $t('profile-completion') }}</span>
        <span>{{ percentageFormatter(progress) }}</span>
      </div>
      <div class="progress" style="height: 4px;">
        <div class="progress-bar bg-success" role="progressbar" :style="{'width': percentageFormatter(progress)}" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>
    <b-modal v-model="showInfoModal" hide-footer hide-header size="md">
      <div class="text-center text-secondary p-2 mt-3">
        <h5>{{ $t('complete-all-fields-in-your-profile-to-reach-100-and-get-profile-verified') }}</h5>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      profileData: [],
      progress: 100,
      showInfoModal: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters['user'];
    },
    userWorkinfo() {
      return this.$store.getters['userWorkInfo'];
    },
    userResearchCreds() {
      return this.$store.getters['userResearchCreds'];
    },
  },
  created() {
    this.$store.dispatch('fetchUserWorkInfo');
    this.$store.dispatch('fetchUserResearchCreds');
  },
  mounted() {
    this.percentage();
    this.$bus.on('profile-progress-submit', () => this.percentage());
  },
  methods: {
    percentage() {
      const type = this.user?.is_industry || this.user?.is_hcp || this.user?.is_other ? 'valid' : null;
      const profileData = [
        // general
        this.user?.profile_image_url,
        this.user?.name_prefix,
        this.user?.first_name,
        this.user?.last_name,
        this.user?.name_suffix,
        this.user?.phone_number,
        this.user?.address,
        this.user?.city,
        this.user?.country,
        this.user?.zoom_user,
        // security/login
        this.user?.email,
        this.user?.email_verified_at,
        // workinfo
        this.userWorkinfo?.employment_status,
        this.userWorkinfo?.workplace,
        this.userWorkinfo?.job_title,
        this.userWorkinfo?.job_category_id,
        this.userWorkinfo?.job_category_other,
        this.userWorkinfo?.workplace_address,
        this.userWorkinfo?.city,
        this.userWorkinfo?.country,
        this.userWorkinfo?.cv_file,
        this.userWorkinfo?.cv_file_last_update_date,
        // research creds
        this.userResearchCreds?.professional_experience_years,
        this.userResearchCreds?.clinical_experience_years,
        this.userResearchCreds?.num_clinical_studies_as_principal_investigator,
        this.userResearchCreds?.num_clinical_studies_as_sub_investigator,
        // type validation
        type,
      ];

      const nonNullValues = profileData.filter((element) => element !== null && element !== undefined);
      const numberOfNonNullElements = nonNullValues.length;
      const totalElements = profileData.length;
      const percentageComplete = (numberOfNonNullElements / totalElements) * 100;
      this.progress = Math.round(percentageComplete * 100) / 100; // round to two decimal places
    },
    percentageFormatter(value){
      if (value > 99) {
        return '100%';
      } else {
        // whole number
        return (parseFloat(value).toFixed(0) + '%');
      }
    },
  },
};
</script>